import Header from "./Component/Header/Header";
import Mov from "./Component/mov/Mov";
import AboutMe from "./Component/AboutMe/AbotMe";
import Tasty from "./Component/tasty/Tasty";
import Music from "./Component/Music/Music";
import DesignShop from "./Component/DesignSHop/DesignShop";
import Est from "./Component/Est/Est";
import Trash from "./Component/Trash/Trash";

import Footer from "./Component/footer/footer";
import Contact from "./Component/Contact/Contact";
import { useState } from "react";
import Buybutton from "./Component/Button/Buybutton";
import Gutschein from "./Component/Gutschein/gutschein";
import Paypal from "./Component/Gutschein/paypal";
import "./App.css";

function App() {
	const [showModal, setShowModal] = useState(true);
	window.onbeforeunload = function () {
		window.scrollTo(0, 0);
	};
	return (
		<div className='App'>
			<main>
				<div className='header'>
					<Header />
				</div>
				<div className='AboutMeDiv'>
					<AboutMe />
				</div>

				<div className='movDiv'>
					<Mov />
				</div>

				<div className='tastyDiv'>
					<Tasty />
				</div>
				<div className='musicDiv'>
					<Music />
				</div>
				<div className='shopDiv'>
					<DesignShop />
				</div>
				<div className='estDiv'>
					<Est />
				</div>
				{/* <div className='trashDiv'>
					<Trash />
				</div> */}

				{showModal ? (
					<>
						<Paypal />
					</>
				) : null}
				{/* <Buybutton /> */}
				<div className='contactDiv'>
					<Contact />
				</div>
				<div className='footerDiv'>
					<Footer />
				</div>
			</main>
		</div>
	);
}

export default App;
